// Bridge between Preact (JSX, VNode) and the legacy DOM-based render path.
//
// 기존 코드는 ui/dom.ts의 h()가 HTMLElement를 직접 반환하는 모델로 짜여 있음.
// Week 2 마이그레이션 동안 두 시스템이 공존해야 하므로, JSX 컴포넌트를
// 기존 DOM 트리에 끼워 넣을 때 이 헬퍼로 wrapper에 render한 뒤 그 wrapper를
// 그대로 부모에 append. wrapper는 display:contents로 두면 시각적으로 무영향.
//
// 동적 컴포넌트(상태 갱신 필요)인 경우 wrapper를 가지고 있어야 Preact가
// 다시 reconcile할 수 있음. 정적 카드여도 wrapper째 보관해 메모리 누수 없게 함.

import { h, render, type VNode } from "preact";

export function mountPreact(vnode: VNode): HTMLElement {
  const wrapper = document.createElement("div");
  wrapper.style.display = "contents";
  render(vnode, wrapper);
  return wrapper;
}

// DomNode — JSX 트리 안에서 imperative HTMLElement(예: matchCard 결과)를
// 자식으로 넣고 싶을 때. ref 콜백으로 직접 appendChild.
export function DomNode({ node }: { node: HTMLElement | null | undefined }): VNode | null {
  if (!node) return null;
  return h("div", {
    style: "display:contents",
    ref: (el: HTMLElement | null) => {
      if (!el) return;
      if (el.firstChild !== node) {
        el.innerHTML = "";
        el.appendChild(node);
      }
    },
  });
}
